import { TextInput, useRecordContext } from "react-admin";
import Grid from "@mui/material/Grid";
import { ManualITSInput } from "../create/components/ManualItsInput";
import { SABIL_ITS_CLOSED_HELPER, SABIL_ITS_CORRECTION_HELPER } from "../sabil-its-correction";
import { isMuttavatteenSabilType } from "../sabil-household-members";

const ChulaSabilEditFields = () => {
  const record = useRecordContext();
  const isClosed = Boolean(record?.closedAt);
  const showHolderWhatsapp = isMuttavatteenSabilType(record?.sabilType as string | undefined);

  return (
    <Grid container spacing={1}>
      <Grid size={{ xs: 12, lg: 6 }}>
        <ManualITSInput
          source="itsNo"
          label="ITS No."
          fullWidth
          disabled={isClosed}
          helperText={isClosed ? SABIL_ITS_CLOSED_HELPER : SABIL_ITS_CORRECTION_HELPER}
        />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <TextInput source="name" label="Full Name" fullWidth />
      </Grid>
      {showHolderWhatsapp ? (
        <Grid size={{ xs: 12, lg: 6 }}>
          <TextInput
            source="whatsappNo"
            label="WhatsApp"
            placeholder="+919876543210"
            fullWidth
            required
            helperText="E.164 format with '+' prefix (e.g. +919876543210)"
          />
        </Grid>
      ) : null}
      <Grid size={{ xs: 12, lg: 6 }}>
        <TextInput source="address" label="Address" fullWidth />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <TextInput source="pan" label="PAN" fullWidth />
      </Grid>
      <Grid size={{ xs: 12, lg: 6 }}>
        <TextInput source="remarks" label="Remarks" fullWidth />
      </Grid>
    </Grid>
  );
};

export default ChulaSabilEditFields;
